import { Fragment } from "react";
import { Link } from "react-router-dom";

// Текст со ссылками внутри абзаца или пункта списка.
//
// articlesData.js — обычный .js, JSX в нём написать нельзя, поэтому такой текст
// задаётся массивом кусков:
//
//   parts: [
//     "Разбор рисков — на странице ",
//     { to: "/nakrutka-pf-yandex", text: "накрутка ПФ через тестировщиков" },
//     ". Смотрите также ",
//     { href: "https://yandex.ru/support/…", text: "справку Яндекса" },
//     "."
//   ]
//
//   { to }   — внутренняя ссылка, react-router Link (в DOM это <a href>)
//   { href } — внешняя, открывается в новой вкладке
//   { bold } — жирный фрагмент, тем же <span>, что и bold у Description
//
// Ссылки нужны настоящими тегами: без них перелинковки для робота не
// существует, а справка Яндекса прямо просит делать ссылки текстовыми.
export default function renderParts(parts) {
  return parts.map((part, index) => {
    if (typeof part === "string") return part;

    if (part.bold) return <span key={index}>{part.bold}</span>;

    if (part.href)
      return (
        <a key={index} href={part.href} target="_blank" rel="noopener noreferrer">
          {part.text}
        </a>
      );

    if (part.to)
      return (
        <Link key={index} to={part.to}>
          {part.text}
        </Link>
      );

    return <Fragment key={index} />;
  });
}
